import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { createAlert } from '../scripts/createAlert';

export default class extends Controller {
  static targets = [ "note", "notesContainer" ]
  static values = {
    seasonId: Number,
    team: Number,
    player: Number,
    seasonSlug: String,
    url: String
  }

  connect() {
    // console.log("Hello, Stimulus from Player Note controller!", this.element)
    // console.log({ noteContainer: this.notesContainerTarget})
    // console.log({ team: this.teamValue });
    // console.log({ player: this.playerValue });

    Sortable.create(this.notesContainerTarget, {
      draggable: '.note-sortable',
      dataIdAttr: 'data-sortable-id',
      handle: ".sortable-handle",  // Drag handle selector within list items

      // Changed sorting within list
      onUpdate: (event) => {
        const sortableIds = Array.from(this.noteTargets).map(elm => elm.dataset.sortableId)

        const headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }

        var token;
        if (document.querySelector('meta[name="csrf-token"]')) {
          token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

          headers['X-CSRF-Token'] = token;
        }

        fetch(`/entity/teams/${this.teamValue}/players/${this.playerValue}/reorder_notes`, {
          method: 'PATCH',
          headers,
          body: JSON.stringify({ ordered_note_ids: sortableIds })
        }).then(() => {
          createAlert('success', 'Note order updated')
        })
      }
    });

  }

  addNote() {
    fetch(this.urlValue).then(res => res.text()).then(partial => {
      partial = partial.replace(/NEW_ID/g, this.noteTargets.length + 1)
      partial = partial.replace(/SEASON_ID/g, this.seasonIdValue)
      partial = partial.replace(/SEASON_SLUG/g, this.seasonSlugValue)

      this.notesContainerTarget.insertAdjacentHTML( 'beforeend', partial );
    });
  }
}

